import { IonIcon } from '@ionic/react';
import { personCircleOutline } from 'ionicons/icons';
import { useNavigate } from 'react-router-dom';

import { useAuth } from "../../context";

import './protected-routes.css';

export default function UserProfile() {
    const auth = useAuth();
    const navigate = useNavigate();

    if (!auth?.user) {
        return (<></>);
    }

    const logoutCallback = () => {
        const env_oidc_server = process.env.REACT_APP_OIDC_SERVER;
        const env_app_hostname = process.env.REACT_APP_HOSTNAME;
        const isLocalhost = env_app_hostname?.includes('localhost');
        if (isLocalhost) {
            navigate('/login');
        } else {
            window.location.assign(`${env_oidc_server}logout?next=${env_app_hostname}login`);
        }
    }
    const logout = () => {
        auth.logout(logoutCallback);
    };
    const username = new Date(auth.user.expires_at).toISOString(); // TODO get user profile from API

    return (
        <>
            <button className="profile" title={username} type="button" onClick={() => navigate('/profile')}><IonIcon icon={personCircleOutline} size="large"></IonIcon></button>
            <button className="accountAction" onClick={() => logout()} type="button">Logout</button>
        </>
    );
}